<template>
  <div id="chat_bot" style="display: block;">
    <div class="chat_icon">
      <a href="javascript:void(0);" @click="chatOpen()">
        <img class="js-img-switch-sp" :src="chatbotIcon" />
      </a>
    </div>
  </div>
</template>

<script>
import ChatBotService from "@/core/utils/chat-bot-service";
const btnChatBotSp = require("@/assets/images/btn_chatbot_sp.png");
const btnChatBotPc = require("@/assets/images/btn_chatbot_pc.png");

export default {
  name: "ChatBot",
  data() {
    return {
      chatbotIcon: btnChatBotPc
    };
  },
  created() {
    this.getChatBotIcon();
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getChatBotIcon);
    });
  },
  methods: {
    chatOpen() {
      ChatBotService.chatOpen();
    },
    getChatBotIcon() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth < 760) {
        this.chatbotIcon = btnChatBotSp;
      } else {
        this.chatbotIcon = btnChatBotPc;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.getChatBotIcon);
  }
};
</script>
